import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import errorCodes from '@/constants/errors';
import { fetchUserGroups, toggleUserGroupSelected, toggleUserGroupsPresentation } from '../actions/usergroups/read';

const UserGroupsPanelContainer = ({
  canRead,
  children,
  className,
  readErrors,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-user-groups-panel-container', className)}>
      {children}
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  userGroups: { newUserGroupCode, userGroups },
}, { category, displayAs }) => {
  const item = userGroups[category];

  return {
    canCreate: permissions.usergroups.create,
    canRead: permissions.usergroups.read,
    display: displayAs || item.display,
    currentPage: item.currentPage,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    total: item.count,
    usergroups: item.results,
    newUserGroupCode,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchUserGroups,
  onCheckBoxClick: toggleUserGroupSelected,
  togglePresentation: toggleUserGroupsPresentation,
};

export default UserGroupsPanelContainer;
